import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Shield, CheckCircle, XCircle } from "lucide-react";

const LenderVerification = () => {
  const { data: lenders } = useQuery({
    queryKey: ["lenders-verification"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("lenders")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  const handleVerification = async (lenderId: string, status: string) => {
    try {
      const updates = {
        risk_appetite: status === 'verified' ? 'moderate' : null,
        license_number: status === 'verified' ? 'TEMP-' + lenderId.slice(0, 8) : null
      };

      const { error } = await supabase
        .from("lenders")
        .update(updates)
        .eq("id", lenderId);

      if (error) throw error;
    } catch (error) {
      console.error('Error updating lender:', error);
    }
  };

  return (
    <div className="space-y-6">
      {lenders?.map((lender) => (
        <Card key={lender.id} className="p-6">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Shield className="h-6 w-6 text-primary" />
                <h3 className="text-lg font-medium">{lender.institution_name}</h3>
              </div>
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  className="text-green-600"
                  onClick={() => handleVerification(lender.id, "verified")}
                >
                  <CheckCircle className="h-4 w-4 mr-2" />
                  Approve
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  className="text-red-600"
                  onClick={() => handleVerification(lender.id, "rejected")}
                >
                  <XCircle className="h-4 w-4 mr-2" />
                  Reject
                </Button>
              </div>
            </div>
            
            <div className="grid gap-4 md:grid-cols-2">
              <div>
                <p className="text-sm text-muted-foreground">License Number</p>
                <p className="font-medium">{lender.license_number || "Not provided"}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Risk Appetite</p>
                <p className="font-medium capitalize">{lender.risk_appetite || "Not specified"}</p>
              </div>
            </div>
          </div>
        </Card>
      ))}

      {!lenders?.length && (
        <div className="text-center py-10">
          <p className="text-muted-foreground">No lenders pending verification</p>
        </div>
      )}
    </div>
  );
};

export default LenderVerification;